import { useFormikContext } from "formik";
import {
  handleChangeHelper,
  handleOnBlurHelper,
  validateHelper,
} from "./formikSelectHelper";
import { useContext } from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";

function useFormikSelect() {
  const field = useContext(FormikControlContext);
  const { arrayIndex, productName } = field;
  const formik = useFormikContext();
  const { setFieldValue, values } = formik;

  const handleChange = (event) => {
    formik.handleChange(event);
    // Calling helper function
    handleChangeHelper(event, setFieldValue, productName, values, arrayIndex);
  };

  const handleBlur = (event) => {
    // Calling helper function
    handleOnBlurHelper(event, setFieldValue, productName, values, arrayIndex);
  };

  const validate = (value) => {
    return validateHelper(value, field, formik);
  };

  return { handleChange, handleBlur, validate };
}

export default useFormikSelect;
